import { axiosRequest } from "helpers";

export const generalInfoService = {
	sendGeneralInfo,
	getApplicationId
};

const API_URL = process.env.REACT_APP_API_URL;

function sendGeneralInfo(model) {
	const options = {
		method: "POST",
		data: model,
		params: {
			token: model?.token,
		},
		url: `${API_URL}/api/pre_applications/${model?.applicationId}/general_info`,
	};
	return axiosRequest(options);
}

function getApplicationId(token) {
	const options = {
		method: "POST",
		params: {
			token: token,
		},
		url: `${API_URL}/api/pre_applications/initialize`,
	};
	return axiosRequest(options);
}
